import { Button, Image, Modal, Row, Space, Table, Tag } from "antd"
import React, { useState } from "react";
import { CloseCircleFilled, ShopOutlined } from "@ant-design/icons";
import { formatNumber } from "../../../utils/funcHelper";

const ModalSelectedOrder = ({ visible, onCancel, onDelete, data }) => {
    const columns = [
        {
            title: 'Act',
            align: 'center',
            width: 50,
            render: (text, record, index) => <a onClick={() => handleDelete(record.id)}><CloseCircleFilled style={{color: 'red'}}/></a>
        },
        {
            title: 'Image',
            dataIndex: 'first_sku_image',
            key: 'first_sku_image',
            align: 'center',
            width: 60,
            render: (text, record, index) => <div style={{ padding: 1 }}><Image src={text} width={60} height={60} /></div>,
        },
        {
            title: 'Order ID',
            dataIndex: 'order_id',
            key: 'order_id',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                <a style={{ paddingLeft: 8, paddingRight: 8 }}>{text}</a>
            </div>,
        },
        {
            title: 'Customer',
            dataIndex: 'customer',
            key: 'customer',
            width: 200,
            render: (text, record, index) => <div
                style={{
                    paddingLeft: 12, paddingRight: 12
                }}>
                {text}
            </div>,
        },
        {
            title: 'Shop',
            width: 200,
            render: (text, record, index) => <div>
                <Tag icon={<ShopOutlined />} color="#3b5999">
                    {record?.custom_code} - {record?.shop_name}
                </Tag>
            </div>,
        },
        {
            title: 'Order status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 150
        },
        {
            title: 'Titkok status',
            dataIndex: 'tiktok_status',
            key: 'tiktok_status',
            align: 'center',
            width: 150,
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            align: 'center',
            width: 180,
            render: (text, record, index) => <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>{formatNumber(text,2)} $</div>,
        },

        {
            title: 'Items',
            align: 'center',
            dataIndex: 'items_count',
            key: 'items_count',
            width: 100,
            render: (text, record, index) => <div style={{
                paddingLeft: 12, paddingRight: 12
            }}>
                {text} items
            </div>,
        },
        
    ];

    const handleDelete = (id) => {
        onDelete(id);
    }

    return (
        <Modal
            title={'List order selected'}
            open={visible}
            onCancel={onCancel}
            width={'70%'}
            footer={null}
        >
            <Table
                columns={columns}
                className="custom-table-task"
                style={{ marginTop: 12 }}
                dataSource={data}
                rowKey={record => record.id}
                scroll={{ x: 1300 }}
            />
            <Row gutter={16} justify={'end'}>
                <Space>
                    <Button onClick={onCancel}>
                        Close
                    </Button>
                </Space>
            </Row>
        </Modal>
    )
}
export default React.memo(ModalSelectedOrder);

